<script lang="ts">
import { AppVehicleGroupCardComponent } from "./app-vehicle-group-card";
export default AppVehicleGroupCardComponent;
</script>

<template>
    <div
        class="c-product_card"
        v-bind="$attrs"
        :class="{ product__card: source !== 'vehicles-details-swiper' }"
        :style="{ 'margin-left': source === 'vehicles-details-swiper' ? 0 : undefined }"
    >
        <div class="product__card-top container_car-count">
            <div>
                <h5 class="h5 product__card-name" :style="showIcon && groupDto.vehicle_counter > 1 ? 'padding-right: 5.0666666667rem;' : ''">
                    {{ concatenateStrings(groupDto.brands.map((brand) => brand.name)) }}
                    {{ concatenateStrings(groupDto.models) }}
                    {{ concatenateStrings(groupDto.finishes) }}
                </h5>
                <div v-tippy="{ content: vehicleInfoName }">
                    <p class="fz-smaller product__card-model product__card-name">
                        {{ vehicleInfoName }}
                    </p>
                </div>
            </div>
            <div v-if="showIcon && groupDto.vehicle_counter > 1" class="icon_block">
                <div class="title_block">
                    <span class="counter_value">
                        {{ groupDto.vehicle_counter }}
                    </span>
                </div>
                <div style="margin-left: 5px">
                    <img
                        width="44"
                        height="17"
                        :src="`/img/${brandLabel}/icon-cars.png`"
                        alt="#"
                    />
                </div>
            </div>
        </div>

        <div class="product__card-picture" :class="{ 'arrow-hover': arrowHover }">
            <div class="product__card-overlay">
                <div
                    v-if="groupDto.thumbnail_images?.length"
                    class="swiper-container slider__gallery product__card-slider"
                    v-app-gallery
                >
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide dflex"
                            v-for="image in groupDto.thumbnail_images"
                            :key="image.href_small"
                        >
                            <img
                                class="swiper-lazy"
                                :data-src="image.href_small"
                                :style="{
                                    objectFit: 'cover',
                                    'background-color': '#f4f8fd',
                                }"
                            />
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </div>
                    <div
                        class="slider__gallery-arrows product__card-arrows"
                        v-if="groupDto.thumbnail_images.length > 1"
                    >
                        <div
                            @mouseover="arrowHover = true"
                            @mouseleave="arrowHover = false"
                            class="
                                product__card-arrow
                                swiper-button-next
                                product__card-slider-next
                            "
                        ></div>
                        <div
                            @mouseover="arrowHover = true"
                            @mouseleave="arrowHover = false"
                            class="
                                product__card-arrow
                                swiper-button-prev
                                product__card-slider-prev
                            "
                        ></div>
                    </div>
                </div>
                <router-link
                    v-if="groupDto.vehicle_counter > 1"
                    :to="{
                        path: `/auth/vehicles`,
                        query: {
                            ...getVehicleGroupingQueryParameters,
                            ...filters,
                        },
                    }"
                    custom
                    v-slot="{ href, navigate }"
                >
                    <a
                        v-app-auth-required="{
                            role: 'dealer',
                            showLogin: !isAuthenticated,
                            disable: true, // TODO: vehicleDto.promotions === carLabel.specialDeal
                        }"
                        :href="href"
                        class="button button--outline"
                        @click.prevent="
                            () =>
                                routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        "
                    >
                        <i18n-t keypath="carCard.viewVehicles"></i18n-t>
                    </a>
                </router-link>
                <router-link
                    v-else
                    :to="{
                        path: `/auth/vehicle-details/${groupDto.vehicle_ids[0]}`,
                        query: {
                            ...getVehicleGroupingQueryParameters,
                            ...filters,
                        },
                    }"
                    custom
                    v-slot="{ href, navigate }"
                >
                    <a
                        v-app-auth-required="{
                            role: 'dealer',
                            showLogin: !isAuthenticated,
                            disable: true, // TODO: vehicleDto.promotions === carLabel.specialDeal
                        }"
                        :href="href"
                        class="button button--outline"
                        @click.prevent="
                            () =>
                                routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        "
                    >
                        <i18n-t keypath="carCard.viewDetails"></i18n-t>
                    </a>
                </router-link>

                <!-- <button
                    class="button button--outline"
                    @click="() => routeToCarGroup(carGroup)"
                >
                    <i18n-t keypath="carCard.viewSelection"></i18n-t>
                </button> -->
            </div>
        </div>
        <div class="product__card-bottom">
            <div class="product__card-price" v-if="isAuthenticated && groupDto.price_min">
                <div
                    class="price__bottom"
                    v-if="groupDto.price_min && groupDto.price_max"
                >
                    <p class="h4" v-if="groupDto.price_min !== groupDto.price_max">
                        <app-format-currency
                            :value="groupDto.price_min"
                            :currency="currency"
                        />
                        -
                        <app-format-currency
                            :value="groupDto.price_max"
                            :currency="currency"
                        />
                    </p>
                    <p class="h4" v-else>
                        <app-format-currency
                            :value="groupDto.price_min"
                            :currency="currency"
                        />
                    </p>
                    <span class="price__bottom-text">
                        <i18n-t keypath="carCard.excludeVAT"></i18n-t>
                    </span>
                </div>
                <div v-if="groupDto.has_deal" class="special-offer">
                    <i18n-t keypath="carCard.specialOffer"></i18n-t>
                </div>
            </div>
            <div class="product__card-features">
                <div style="display: flex; flex-wrap: wrap;" v-if="groupDto.mileage_min">
                    <div
                        class="features__list-label tooltip__info"
                        style="white-space: nowrap"
                        v-tippy="{
                            content: i18n.t('carCard.kmUsed'),
                            interactive: true,
                        }"
                    >
                        <p
                            class="features__list-text"
                            v-if="groupDto.mileage_min !== groupDto.mileage_max"
                        >
                            {{ groupDto.mileage_min }} -
                            {{ groupDto.mileage_max }}
                            <b>KM</b>
                        </p>
                        <p class="features__list-text" v-else>
                            {{ groupDto.mileage_min }}
                            <b>KM</b>
                        </p>
                    </div>
                    <div
                        class="features__list-label features__list-text"
                        style="white-space: nowrap"
                        v-tippy="{
                            content: i18n.t('carDetails.date'),
                            interactive: true,
                        }"
                    >
                        <p
                            v-if="
                                groupDto.firstregistration_date_max != null &&
                                groupDto.firstregistration_date_min != null
                            "
                        >
                        {{ formatDate(groupDto.firstregistration_date_min) !== formatDate(groupDto.firstregistration_date_max) ? 
                            `${formatDate(groupDto.firstregistration_date_min)} - ${formatDate(groupDto.firstregistration_date_max)}` : 
                            formatDate(groupDto.firstregistration_date_min) }}
                        </p>
                        <p v-else>
                            <b><i18n-t keypath="common.noReg"></i18n-t></b>
                        </p>
                    </div>
                </div>
            </div>

            <div class="product__card-stock">
                <p
                    class="stock__label"
                    v-html="i18n.t('carCard.inStock', groupDto.vehicle_counter)"
                ></p>

                <div
                    v-for="variant in groupDto.exterior_color_variants"
                    v-bind:key="variant.color.id"
                    class="stock__color purple tooltip__info"
                    :class="[`--${variant.color.name}`]"
                    v-tippy="{
                        content: variant.color.name,
                        interactive: true,
                    }"
                    :style="{
                        backgroundColor: variant.color.hex,
                        color: variant.color.is_light ? 'black' : 'white',
                    }"
                >
                    {{ variant.vehicle_counter }}
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
@media (max-width: 768px) {
    .product__card-features,
    .product__card-stock {
        padding: 0px 0 10px 10px;
    }
    .product__card-price {
        padding: 1rem 1.3333333333rem;
    }
}
.icon_block {
    display: flex;
    position: absolute;
    top: 20px;
    right: 20px;
}

.title_block {
    width: auto;
    margin-right: 5px;
    margin-bottom: 3px;
}

.counter_value {
    font-size: 19px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: var(--color-primary);
}

.product__card-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    position: relative;
    cursor: default;
    width: 100%;
    padding-right: 0;
}

.special-offer {
    background-color: #FAB42D;
    color: white;
    padding: 5px 10px;
    width: fit-content;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin: 10px 0;
}
</style>
